import Vue from 'vue'
import Enum from './enum' 
import EnumModule from './module'
 
Vue.use(Enum, EnumModule)